import {createContext} from "react"
export const LocalContext = createContext({
    localContext: null,
    setLocalAction: () => {},
})